import { useIsSmartContractWallet } from '@onramp/hooks/useIsSmartContractWallet';
import type { Screen } from '@onramp/utils/eventing';
import { logNavSignout } from '@onramp/utils/eventing';
import exitWidget from '@onramp/utils/exitWidget';
import { useReffedFunction } from '@onramp/utils/useReffedFunction';

import { getRoute } from '../useOnRampRouter';

export const exitUrl = new URL('exit', process.env.NEXT_PUBLIC_ONRAMP_BASE_URL);

export const useLogout = (signoutSource: Screen) => {
  const isSmartContractWallet = useIsSmartContractWallet();

  return useReffedFunction(async () => {
    try {
      const signoutURL = new URL(getRoute('V2Signout'), process.env.NEXT_PUBLIC_ONRAMP_BASE_URL);
      // Trim ? prefix from search params
      const searchParams = window.location.search.slice(1);
      signoutURL.searchParams.append('returnParams', searchParams);

      logNavSignout(signoutSource);

      if (isSmartContractWallet) {
        // eslint-disable-next-line no-restricted-globals
        const res = await fetch(`${signoutURL}`, {
          redirect: 'manual',
        });

        if (res.ok) {
          exitWidget();
          return;
        }
      }

      window.location.assign(`${signoutURL}`);
    } catch {
      // noop
    }
  });
};
